import React from "react";
import { Spinner } from "react-bootstrap";
import Loading from "../../Components/Loading";
import { useContact } from "./Hooks";

const Data = [
  { icon: "", title: "نام و نام خانوادگی خود را وارد نمایید" },
  { icon: "", title: "شماره همراه خود را وارد نمایید" },
  { icon: "", title: "موضوع پیام خود را وارد نمایید" },
  { icon: "", title: "متن پیام" },
];

const ContactUs = () => {
  const { send, handler, loadingbtn, data, loading } = useContact();
  console.log("asdasdasd ,:", data);
  if (loading) {
    return (
      <div className="about-us container">
        <Loading height={"400px"} />
      </div>
    );
  }
  return (
    <div className="container">
      <div className="contact-us row">
        <div className="box row d-flex justify-content-between col-lg-9">
          <div>
            <div></div>
            <div className="title">تماس با ما:</div>
          </div>

          <div className="col-lg-6 mb-lg-0 mb-3">
            <div>
              <div className="text">
                <div>تلفن پشتیبانی:</div>
                <div>
                  <div>{data?.support_number}</div>
                </div>
              </div>

              <div className="text">
                <div>ایمیل:</div>
                <div>{data?.email}</div>
              </div>

              <div className="text">
                <div>فکس:</div>
                <div>{data?.fax}</div>
              </div>

              <div className="text">
                <div>آدرس:</div>
                <div>
                  <div>
                    <br />
                    {data?.addres}
                  </div>
                </div>
              </div>

              <div className="text">
                <div>ساعات کاری:</div>
                <div>{data?.wotk_time}</div>
              </div>
            </div>

            <div className="gray-text">{data?.notif}</div>
          </div>

          <div className="col-lg-5">
            <div>
              <input
                className="input"
                type={"text"}
                placeholder={"نام و نام خانوادگی خود را وارد نمایید"}
                onChange={({ target: { value } }) => {
                  handler("fullname", value);
                }}></input>
              <input
                className="input"
                type={"number"}
                placeholder={"شماره همراه خود را وارد نمایید"}
                onChange={({ target: { value } }) => {
                  handler("mobile", value);
                }}></input>
              <input
                className="input"
                type={"text"}
                placeholder={"موضوع پیام خود را وارد نمایید"}
                onChange={({ target: { value } }) => {
                  handler("description", value);
                }}></input>
              <textarea
                className="input"
                placeholder={"متن پیام"}
                style={{ height: "250px", padding: "15px" }}
                onChange={({ target: { value } }) => {
                  handler("message", value);
                }}></textarea>
            </div>
            <button onClick={send} disabled={loadingbtn}>
              {loadingbtn ? <Spinner size="md" /> : "ارسال درخواست"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
